import { render, staticRenderFns } from "./AdminSettingsList.vue?vue&type=template&id=1ad32210&"
import script from "./AdminSettingsList.vue?vue&type=script&lang=js&"
export * from "./AdminSettingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad32210')) {
      api.createRecord('1ad32210', component.options)
    } else {
      api.reload('1ad32210', component.options)
    }
    module.hot.accept("./AdminSettingsList.vue?vue&type=template&id=1ad32210&", function () {
      api.rerender('1ad32210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Pages/AdminSettingsList.vue"
export default component.exports